import { trackEvent } from 'util/trackingHelper';
import featureFlags from 'util/featureFlags';

export const trackCardCustomizationStarted = (
  type: string,
  uuid: string,
  projectTrackedEvents: any = [], // eslint-disable-line
  activeMediumKey: string,
  activeSelectionSize: string,
  isCustomPhotoPreviewInUse?: boolean,
  currentFlowUuid?: string | null
): void => {
  const shouldTrackEvent =
    projectTrackedEvents.filter((event: { name: string }) => event.name === 'Customization Started')
      .length === 0;

  if (shouldTrackEvent) {
    const trackingObj = {
      customization_type: type,
      customization_medium: activeMediumKey,
      customization_size: activeSelectionSize,
      card_project_customization_id: uuid,
      ...(featureFlags.get('plpPhotoPreview') && isCustomPhotoPreviewInUse && currentFlowUuid
        ? { flow_run_id: currentFlowUuid }
        : {}),
    };
    trackEvent('Customization Started', trackingObj);
  }
};
